/** Requests from /superadmin pages run as the signed-in superadmin even while impersonating. */
export const isSuperadminPath = (pathname: string) => pathname.startsWith('/superadmin');
